import u from "umbrellajs";

function showOverlay() {
  u(".overlay-glass-effect").addClass("active");
}

function hideModal() {
  u(
    ".modal-custom .modal-custom-background .modal-custom-background__modal .modal-custom-background__modal--svg"
  ).nodes[0].style.opacity = 1;

  u(".modal-custom").addClass("out");

  setTimeout(function () {
    u(".modal-custom").removeClass("active out");

    hideOverlay();

    u("body").nodes[0].style.overflow = "auto";
  }, 600);
}

function hideOverlay() {
  u(".overlay-glass-effect").removeClass("active");
}

function showDataModalCustom(response) {
  showOverlay();
  u(".modal-custom")
    .find(".modal-custom-background__modal--content")
    .html(response);

  u(".modal-custom").addClass("active");

  setTimeout(function () {
    u(
      ".modal-custom .modal-custom-background .modal-custom-background__modal .modal-custom-background__modal--svg"
    ).nodes[0].style.opacity = 0;
  }, 700);

  u("body").nodes[0].style.overflow = "hidden";
}

function showPasswordTokenPanel() {
  const token = new URL(window.location.href).searchParams.get("token");

  fetch(`${MAIN_WEB_ROOT}ajax/app/custom/users/passwordTokenPanel`, {
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
    body: JSON.stringify({
      token: token,
    }),
  })
    .then((response) => response.text())
    .then((response) => {
      showDataModalCustom(response);
    });
}

function showChangePasswordPanel() {
  fetch(`${MAIN_WEB_ROOT}ajax/app/custom/users/changePasswordPanel`, {
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
    body: "html",
  })
    .then((response) => response.text())
    .then((response) => {
      u("#headerPhp .container-options").html(response);

      showDataModalCustom(response);
    });
}

export {
  showOverlay,
  hideModal,
  hideOverlay,
  showDataModalCustom,
  showChangePasswordPanel,
  showPasswordTokenPanel,
};
